import React from 'react';
import { Box } from '@wegroup/design-system';

const ToolbarMobile: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Box
      position="sticky"
      top="0"
      p="4"
      maxW="100vw"
      background="secondary.800"
      borderBottom="1px"
      borderColor="gray.50"
      data-test-id="Flows_QuestionViewHeader"
      zIndex="2"
    >
      {children}
    </Box>
  );
};

export default ToolbarMobile;
